/** @jsx h **/

import { component, Signal, h } from "alfama";
import { BufferRoutePattern } from "@gratico/sdk";
import { RouterContext, extractParameters } from "alfama-router";
import { IBufferRouteParams } from "@gratico/sdk";
import { ChatInner } from "./Chat";
import { ShellProps } from "../../@types";

export const Chat = component<ShellProps>(
  "Chat",
  (props, { signal, store, wire, onMount, onUnmount, getContext }) => {
    const router = getContext(RouterContext).get();
    const $activeRoute = signal<Partial<IBufferRouteParams> | undefined>(
      "route",
      undefined
    );
    const handler = () => {
      const params = extractParameters<Partial<IBufferRouteParams>>(
        BufferRoutePattern,
        router.location.pathname
      );
      $activeRoute.set(params);
    };
    onMount(() => {
      window.addEventListener("popstate", handler);
    });
    onUnmount(() => {
      window.removeEventListener("popstate", handler);
    });
    return <ChatInner {...props} />;
  }
);
